module.exports = __webpack_public_path__ + "static/img/woods-mitchell.ccea718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/woods-mitchell.jpg
// module id = SFua
// module chunks = 0